import { gql } from '@apollo/client';

export const MEDCALL2_SEARCH_MEDICATIONS = gql`
  query Medcall2SearchMedications($searchText: String!) {
    medcallSearchMedications: medcall2SearchMedications(searchText: $searchText) {
      displayName
      drugbankPcid
      externalId
      hits { value }
      isCustom
      level
      medicineDetail
      name
      source
      uuid
    }
  }
`;

export const MEDCALL2_MEDICATION_STRENGTHS = gql`
  query Medcall2MedicationStrengths($externalId: String!, $medicineName: String) {
    medcallMedicationStrengths: medcall2MedicationStrengths(externalId: $externalId, medicineName: $medicineName) {
      displayName
      externalId
      isCustom
      name
      strength
    }
  }
`;
